import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  pt: {
    translation: {
      "header_home": "Temos o projeto de marmoraria ideal para você.",
      "header_home_desc":"Tenha segurança e praticidade para a sua reforma ou inicio de obra",
      "btn_request": "Quero orçar meu projeto",
      "galery_title": "Confira nossos melhores projetos",
      "galery_kitchen": "Cozinhas",
      "galery_kitchen_desc": "Para você que busca um projeto para sua cozinha.",
      "galery_laundry": "Lavanderias",
      "galery_laundry_desc": "Inspire-se com ideias para sua lavandeira.",
      "galery_rooms": "Salas",
      "galery_rooms_desc": "Sabe aquele cantinho favorito? temos!!",
      "galery_bathrooms": "Banheiros",
      "galery_bathrooms_desc": "O banheiro dos seus sonhos te espera.",
      "services_help_title": "Iremos te ajudar durante toda a sua obra",
      "services_help_content": "Não tenha preocupação, a nossa equipe de atendimento vai te auxiliar em todas as etapas do andamento do seu orçamento. Mas se precisar de algo é só entrar em contato, ok?",
      "services_security_title": "Garantimos segurança e preço justo",
      "services_security_content": "Com segurança e preço justo a Nanoprice garante a melhor entrega e experiência para você desde o começo até o fim do seu projeto.",
      "services_connect_title": "Conectamos você com os melhores profissionais",
      "services_connect_content": "Assim que você realizar o seu orçamento, iremos procurar o melhor profissional para realizar o seu projeto de marmoraria.",
      "about_us_1": "O que os nossos",
      "about_us_2": "clientes",
      "about_us_3": "falam",
      "about_us_4": "sobre nós",
      "about_us_5": "como nós",
      "about_us_6": "fazemos",
      "clients_content_1": "Excelente Experiência! Fui atendido pelo Orlando que coloca o cliente em primeiro lugar. Ajuda a resolver de forma rápida, e garantir a satisfação do cliente!",
      "clients_content_2": "Atendimento excelente, cumpre os prazos estipulados e consegue resolver o problema sem complicações, fora a qualidade, que é incrível!",
      "clients_content_3": "Fechei meu projeto com a Nano e só tenho elogios, atendimento impar e processos muito bem elaborados facilitando a vida do cliente.",
      "clients_content_rage": "NOTA DE EXCELÊNCIA",
      "title_link_about_us": "Veja o que falam sobre a nano",
      "nano_midia_1": "Estamos",
      "nano_midia_2": "na",
      "nano_midia_3": "mídia",
      "marble_title": "Você trabalha como marmorista?",
      "marble_subtitle": "Temos uma solução ideal para o seu negócio!",
      "btn_solution": "Conheça a solução",
      "menu": {
        "Materiais": "materiais",
        "Login": "login"
      },
      "filter": {
        "filter_name": "filtro",
        "filter_btn_clear": "limpar filtros",
        "colapse_btn_application": "aplicação",
        "colapse_btn_original_material": "aplicação",
        "colapse_btn_original_colors": "cores",
        "colapse_btn_original_finishments": "acabamentos",
        "applications": {
          "external_coating": "área externa",
          "inner_wall": "área interna",
          "kitchen_bench": "bancada cozinha",
          "restroom_stand": "bancada banheiro",
          "service_area": "área de serviço",
          "kitchen": "cozinha",
          "barbecue_grill": "churrasqueira",
          "fireplace": "lareira",
          "restroom": "banheiro",
          "staircase": "escada",
          "toilet": "lavabo",
          "threshold_baguette": "soleira e baguete",
          "floor_cladding": "piso e revestimento"
        },
        "material": {
          "natural": "natural",
          "industrializado": "industrializado",
          "granito": "granito",
          "mármore": "mármore",
          "mármore composto": "mármore composto",
          "ônix": "ônix",
          "travertino": "travertino",
          "quartzo": "quartzo",
          "quartzito": "quartzito",
          "ultra compacto": "ultra compacto"
        },
        "colors": {
          "amarelo": "amarelo",
          "azul": "azul",
          "bege": "bege",
          "branco": "branco",
          "rosa": "rosa",
          "verde": "verde",
          "vermelho": "vermelho",
          "cinza": "cinza",
          "marrom": "marrom",
          "preto": "preto",
          "laranja": "laranja",
          "castanho": "castanho",
          "dourado": "dourado",
          "roxo": "roxo",
          "creme": "creme",
          "translúcido": "translúcido"
        },
        "finishing": {
          "bruto": "bruto",
          "polido": "polido",
          "levigado": "levigado",
          "escovado": "escovado",
          "flameado": "flameado",
          "leathered": "leathered",
          "jateado": "jateado",
          "acetinado": "acetinado"
        }
      },
      "buttons": {
        "filters": {
          "show": "mostrar",
          "results": "resultado",
          "favorites": "favoritos"
        }
      }
    }
  },
  en: {
    translation: {
      "header_home": "We have the ideal marble project for you.",
      "header_home_desc":"Have security and practicality for your renovation or start of work",
      "btn_request": "budget my project",
      "galery_title": "Check out our best projects",
      "galery_kitchen": "kitchen",
      "galery_kitchen_desc": "For you looking for a project for your kitchen.",
      "galery_laundry": "laundry",
      "galery_laundry_desc": "Get inspired with ideas for your laundry room.",
      "galery_rooms": "Rooms",
      "galery_rooms_desc": "You know that favorite corner? we have!!",
      "galery_bathrooms": "Bathrooms",
      "galery_bathrooms_desc": "The bathroom of your dreams awaits you.",
      "services_help_title": "We will help you throughout your work",
      "services_help_content": "Don't worry, our service team will assist you in all stages of your budget progress. But if you need anything just get in touch, okay?",
      "services_security_title": "We guarantee safety and a fair price.",
      "services_security_content": "With security and a fair price, Nanoprice guarantees the best delivery and experience for you from the beginning to the end of your project.",
      "services_connect_title": "We connect you with the best professionals",
      "services_connect_content": "As soon as you make your budget, we will look for the best professional to carry out your marble project.",
      "about_us_1": "what our",
      "about_us_2": "customers",
      "about_us_3": "talk",
      "about_us_4": "about us",
      "about_us_5": "how we",
      "about_us_6": "do",
      "clients_content_1": "Excellent Experience! I was served by Orlando who puts the customer first. Helps resolve quickly, and ensure customer satisfaction!",
      "clients_content_2": "Excellent service, meets the stipulated deadlines and manages to solve the problem without complications, apart from the quality, which is incredible!",
      "clients_content_3": "I closed my project with Nano and I only have compliments, unique service and very well-designed processes facilitating the customer's life.",
      "clients_content_rage": "NOTE OF EXCELLENCE",
      "title_link_about_us": "See what people say about nano",
      "nano_midia_1": "We are",
      "nano_midia_2": "on",
      "nano_midia_3": "midia",
      "marble_title": "Do you work as a marble worker?",
      "marble_subtitle": "We have an ideal solution for your business!",
      "btn_solution": "Know the solution",
      "menu": {
        "Materiais": "materials",
        "Login": "login"
      },
      "filter": {
        "filter_name": "filters",
        "filter_btn_clear": "clear filters",
        "colapse_btn_application": "application",
        "colapse_btn_original_material": "raw material",
        "colapse_btn_original_colors": "colors",
        "colapse_btn_original_finishments": "finishes",
        "applications": {
          "external_coating": "external area",
          "inner_wall": "internal area",
          "kitchen_bench": "kitchen bench",
          "restroom_stand": "bathroom bench",
          "service_area": "service area",
          "kitchen": "kitchen",
          "barbecue_grill": "barbecue grill",
          "fireplace": "fireplace",
          "restroom": "bathroom",
          "staircase": "stairs",
          "toilet": "toilet",
          "threshold_baguette": "sill and baguette",
          "floor_cladding": "floor and coating"
        },
        "material": {
          "natural": "natural",
          "industrializado": "industrialized",
          "granito": "granite",
          "mármore": "marble",
          "mármore composto": "composite marble",
          "ônix": "onyx",
          "travertino": "travertine",
          "quartzo": "quartz",
          "quartzito": "quartzite",
          "ultra compacto": "ultra compact"
        },
        "colors": {
          "amarelo": "yellow",
          "azul": "blue",
          "bege": "beige",
          "branco": "white",
          "rosa": "pink",
          "verde": "green",
          "vermelho": "red",
          "cinza": "grey",
          "marrom": "brown",
          "preto": "black",
          "laranja": "orange",
          "castanho": "dark brown",
          "dourado": "golden",
          "roxo": "purple",
          "creme": "cream",
          "translúcido": "translucent"
        },
        "finishing": {
          "bruto": "brute",
          "polido": "polished",
          "levigado": "levigado",
          "escovado": "brushed",
          "flameado": "flamed",
          "leathered": "leathered",
          "jateado": "sandblasted",
          "acetinado": "satiny"
        }
      },
      "buttons": {
        "filters": {
          "show": "show",
          "results": "results",
          "favorites": "favorites"
        }
      }
    }
  }
};

let language = "pt"

if (navigator.language) {

    const array = navigator.language.split('-')

    language = array[0]

}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: language,
    fallbackLng: "en", 
    interpolation: {
      escapeValue: false
    }
  });

  export default i18n;